import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/**
 * Информация о модуле backend-а
 */
let BdpkApiInfo = class BdpkApiInfo {
};
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiVersion", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiTitle", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiDescription", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiLicense", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiLicenseUrl", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiContributorName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiContributorEmail", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "apiContributorUrl", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "branch", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "commitId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String }),
    tslib_1.__metadata("design:type", String)
], BdpkApiInfo.prototype, "commitDateTime", void 0);
BdpkApiInfo = tslib_1.__decorate([
    jsonObject()
], BdpkApiInfo);
export { BdpkApiInfo };
